import { AnyAction, Reducer } from '@reduxjs/toolkit';

export function pipeReducers<S, A extends AnyAction>(...reducers: Reducer<S, A>[]): Reducer<S, A> {
  return (state, action) => reducers.reduce((state, reducer) => reducer(state, action), state as S);
}
